@if (formGroup) {
  <ng-container [formGroup]="formGroup">
    <mat-form-field>
      <mat-label>
        {{controlLabel | translate}}
        @if (isRequiredField) {
          <span></span>
        }
      </mat-label>
      <mat-select [formControlName]="controlName"
        [id]="controlName"
        (selectionChange)="onSelectionChanged($event)"
        (openedChange)="onOpenedChanged($event)"
        [placeholder]="controlLabel | translate"
        [multiple]="multiple">
        @if ((multiple) || showAllOption) {
          <mat-option
            (click)="multiple && multipleSelection.toggleAllSelection()"
            [value]="allValue">
            {{showAllLabel | translate}}
          </mat-option>
        }
        @if (showNoneOption) {
          <mat-option
            (click)="multiple && multipleSelection.toggleNoneSelection()"
            [value]="noneValue">
            {{showNoneLabel | translate}}
          </mat-option>
        }
        @if (showDefaultOption) {
          <mat-option
            (click)="multiple && multipleSelection.toggleDefaultSelection()"
            [value]="defaultValue">
            {{showDefaultLabel | translate }}
          </mat-option>
        }
        @if (isOptionObject) {
          @for (option of options; track option) {
            <mat-option
              [value]="option[optionIdKey]"
              [disabled]="isOptionDisabled(option[optionIdKey])">
              {{ option[optionValueKey] | translate }}
            </mat-option>
          }
        }
        @if (!isOptionObject) {
          @for (option of options; track option) {
            <mat-option
              [value]="option"
              [disabled]="isOptionDisabled(option)">
              {{ option | translate }}
            </mat-option>
          }
        }
      </mat-select>
      @if (hasValidValue() && showResetButton) {
        <button mat-button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="resetFieldValue($event)">
          <mat-icon>close</mat-icon>
        </button>
      }
      @if (formGroup.get(controlName).errors?.required) {
        <mat-error>
          {{controlLabel + ' is required.' | translate}}
        </mat-error>
      }
      @if (formGroup.get(controlName).errors?.invalid) {
        <mat-error>
          {{'The duration cannot exceed the time recurrence.' | translate}}
        </mat-error>
      }
    </mat-form-field>
  </ng-container>
}

@if (!formGroup) {
  <mat-form-field>
    <mat-label>
      {{controlLabel | translate}}
    </mat-label>
    <mat-select [(ngModel)]="model" [id]="controlName"
      (selectionChange)="onSelectionChanged($event)"
      (openedChange)="onOpenedChanged($event)"
      [placeholder]="controlLabel | translate"
      [multiple]="multiple">
      @if (showAllOption) {
        <mat-option
          [value]="allValue">
          {{showAllLabel | translate}}
        </mat-option>
      }
      @if (showNoneOption) {
        <mat-option
          [value]="noneValue">
          {{showNoneLabel | translate}}
        </mat-option>
      }
      @if (showDefaultOption) {
        <mat-option
          [value]="defaultValue">
          {{showDefaultLabel | translate}}
        </mat-option>
      }
      @if (isOptionObject) {
        @for (option of options; track option) {
          <mat-option
            [value]="option[optionIdKey]"
            [disabled]="isOptionDisabled(option[optionIdKey])">
            {{ option[optionValueKey] | translate }}
          </mat-option>
        }
      }
      @if (!isOptionObject) {
        @for (option of options; track option) {
          <mat-option
            [value]="option"
            [disabled]="isOptionDisabled(option)">
            {{ option | translate }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>
}
